import React from "react";
import { Users, Award, TrendingUp, Globe2 } from "lucide-react";

const highlights = [
  { icon: <Users size={20} />, title: "Expert Team", body: "Our professionals bring over 10 years of combined experience in aviation technology and IT infrastructure.", cls: "" },
  { icon: <Award size={20} />, title: "Industry Leaders", body: "Certified specialists with deep expertise in air traffic management systems and enterprise solutions.", cls: "green" },
  { icon: <TrendingUp size={20} />, title: "Proven Track Record", body: "Successfully delivered 50+ projects across 5+ countries with industry-leading partners.", cls: "red" },
  { icon: <Globe2 size={20} />, title: "Global Experience", body: "Working with international organizations and understanding diverse market requirements.", cls: "" },
];

const stats = [
  { n: "10+", l: "Years of Experience" },
  { n: "50+", l: "Certified Professionals" },
  { n: "100%", l: "Client Satisfaction" },
];

export default function Team() {
  return (
    <section id="team" data-testid="team-section" className="snap-section">
      <div className="max-w-[1280px] mx-auto px-6 w-full">
        <div className="max-w-3xl mb-6">
          <div className="section-eyebrow">Our People</div>
          <h2 className="section-title" data-testid="team-title">Our Expert Team</h2>
          <p className="section-subtitle" data-testid="team-subtitle">
            Experienced professionals with over 10 years of industry expertise, combining deep technical knowledge with practical delivery experience to solve unique client challenges.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          {highlights.map((h, i) => (
            <div key={h.title} data-testid={`team-highlight-${i}`} className="glass-card p-5">
              <div className={`svc-icon ${h.cls} mb-4`} style={{ width: 42, height: 42 }}>{h.icon}</div>
              <h3 className="text-white text-base font-semibold mb-1.5" style={{ fontFamily: "Sora, sans-serif" }}>{h.title}</h3>
              <p className="text-[#a6b3c8] text-[13px] leading-relaxed">{h.body}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-3 gap-4 max-w-3xl">
          {stats.map((s, i) => (
            <div key={s.l} data-testid={`team-stat-${i}`} className="glass-card p-5 text-center">
              <div className="stat-num" style={{ fontSize: "clamp(28px, 3.6vw, 40px)" }}>{s.n}</div>
              <div className="text-[#a6b3c8] mt-2 text-xs uppercase tracking-wider" style={{ fontFamily: "Sora, sans-serif" }}>{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
